import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from "axios"
import Buefy from 'buefy';
import VueSignaturePad from 'vue-signature-pad';
import '@/assets/sass/main.scss'
import '@mdi/font/css/materialdesignicons.css'

import constants from "@/utility/constants"
import helpers from "@/utility/helpers";
import trustedDevice from "@/utility/trustedDevice";

//Auth
import auth from '@websanova/vue-auth/dist/v2/vue-auth.esm';
import driverAuthBearer from '@websanova/vue-auth/dist/drivers/auth/bearer.esm';
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm';

// Axios modifications
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

//Global fix to modify default toJSON/toISOString from '2022-11-20T23:00:00.000Z' to '2022-11-20T23:00:00Z'
//because Vapor/Swift does only understand latter to parse into Date object
Date.prototype.toJSON = function () {
  return this.toISOString().slice(0,-5)+"Z"
}

// The login answers with a trusted-device token whenever the user asked to be remembered
// and the company allows it. vue-auth swallows the login response body (it hands on the
// /auth/me payload instead), so the token is picked up here, where the raw response is
// still available.
axios.interceptors.response.use((response) => {
  if (response?.data?.trustedDeviceToken) {
    trustedDevice.stashPending(response.data.trustedDeviceToken)
  }

  return response
})

//Axios global registration
Vue.use({
  install (Vue) {
    Vue.prototype.$api = axios
  }
})

Vue.config.productionTip = false
/**
 * Auth
 */
Vue.use(auth, {
  plugins: {
    http: axios, // Axios
    // http: Vue.http, // Vue Resource
    router: router,
  },
  drivers: {
    auth:   driverAuthBearer,
    http:   driverHttpAxios,
    router: driverRouterVueRouter
  },
  options: {
    rolesKey: 'role.slug',
    notFoundRedirect: { name: 'login' },
    fetchData: { url: 'auth/me' },
    refreshData: { url: 'auth/refresh' },
    loginData: { url: 'auth/login' },
    parseUserData: function(data) {
      return data
    }
  },
});

// Buefy
Vue.use(Buefy)

Vue.use(VueSignaturePad)

// Add constants
Vue.use({
  install(Vue) {
    Vue.prototype.$constants = constants;
    Vue.constants = constants;
  },
});

// Add helpers
Vue.use({
  install(Vue) {
    Vue.prototype.$helpers = helpers
    Vue.helpers = helpers
  }
})

// Before the router exists: VueRouter resolves the initial route while the root
// instance is being created, so a `beforeCreate` hook would hydrate the store
// too late and the feature guard would bounce a reloaded URL to the dashboard.
store.commit('initialiseStore')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')